﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanCalcViewController = void 0;
const BiMath_1 = require("../../../BiMath");
class LoanCalcViewController {
    constructor(view) {
        this._view = view;
        const ctrl = this._view.ctrls;
        this._tabs = [ctrl.tabBorrow, ctrl.tabRepay, ctrl.tabTransfer, ctrl.tabClaim, ctrl.tabPLSV, ctrl.tabRedeemCalc];
        this._tabsBtns = [ctrl.btnTabBorrow, ctrl.btnTabRepay, ctrl.btnTabTransfer, ctrl.btnTabClaim, ctrl.btnTabPLSV, ctrl.btnTabRedeemCalc];
        this._tabsResetFunc = [() => { this.borrowReset(); }, () => { this.repayReset(); }, () => { this.transferReset(); }, () => { this.claimReset(); }, () => { this.plsvReset(); }, () => { }];
        ctrl.btnTabBorrow.onclick = () => this.activeTab(ctrl.tabBorrow);
        ctrl.btnTabRepay.onclick = () => this.activeTab(ctrl.tabRepay);
        ctrl.btnTabTransfer.onclick = () => this.activeTab(ctrl.tabTransfer);
        ctrl.btnTabClaim.onclick = () => this.activeTab(ctrl.tabClaim);
        ctrl.btnTabPLSV.onclick = () => this.activeTab(ctrl.tabPLSV);
        ctrl.btnTabRedeemCalc.onclick = () => this.activeTab(ctrl.tabRedeemCalc);
        ctrl.hidderTransferAdditional.onclick = () => {
            if (ctrl.hidderTransferAdditional.hasClass('active')) {
                ctrl.hidderTransferAdditional.removeClass('active');
                ctrl.blockTransferAdditional.hide();
            }
            else {
                ctrl.hidderTransferAdditional.addClass('active');
                ctrl.blockTransferAdditional.show();
            }
        };
    }
    showAllTabs() {
        const ctrl = this._view.ctrls;
        ctrl.tabBorrow.show();
        ctrl.tabPLSV.show();
        ctrl.tabRepay.show();
        ctrl.tabTransfer.show();
        ctrl.tabClaim.show();
        ctrl.tabRedeemCalc.show();
        ctrl.btnTabBorrow.show();
        ctrl.btnTabRepay.show();
        ctrl.btnTabTransfer.show();
        ctrl.btnTabPLSV.show();
        ctrl.btnTabClaim.show();
        ctrl.btnTabRedeemCalc.show();
    }
    closeTab() {
        this._tabs.forEach((t) => t.hide());
        this._tabs.forEach((b) => b.removeClass('selected'));
        this._tabsBtns.forEach((b) => b.removeClass('selected'));
    }
    activeTab(tab) {
        this.closeTab();
        const ctrl = this._view.ctrls;
        const index = this._tabs.indexOf(tab);
        this._tabs[index].addClass('selected');
        this._tabsBtns[index].addClass('selected');
        this._tabsResetFunc[index].call(this);
        tab.show();
        //
        ctrl.btnTransferSubmit.disable();
    }
    getActiveTab() { return this._tabs.find(b => b.hasClass('selected')); }
    borrowReset() {
        const ctrl = this._view.ctrls;
        ctrl.iBorrowValueUSDL.value = '';
        ctrl.iDepositValuePLS.value = '';
        ctrl.lTxDepositBorrow.text = "0";
        ctrl.lTxDepositLoan.text = "0";
        ctrl.lTxDepositFee.text = "0";
        ctrl.lTxDepositValue.text = "0";
        ctrl.btnBorrowSubmit.disable();
    }
    repayReset() {
        const ctrl = this._view.ctrls;
        ctrl.iRepayValueUSDL.value = '';
        ctrl.lTxRepayColl.text = "0";
        ctrl.lTxRepayValue.text = "0";
        ctrl.btnRepaySubmit.disable();
    }
    plsvReset() {
        const ctrl = this._view.ctrls;
        this.tokenizeReset();
        this.detokenizeReset();
    }
    transferReset() {
        const ctrl = this._view.ctrls;
        ctrl.lTxTransferAddColl.text = "0";
        ctrl.lTxTransferToAddr.text = "0x00";
        ctrl.lTxTransferToFCR.text = "0";
        ctrl.lTxTransferAddColl.text = "0";
        ctrl.lTxTransferFee.text = "0";
        ctrl.lTxTransferFlashLoanFee.text = "0";
        ctrl.lTxTransferOwnUsdl.text = "0";
        ctrl.lTxTransferNewLoanAmount.text = "0";
        ctrl.btnTransferSubmit.disable();
        ctrl.iTransferValueUSDL.value = '';
        this._view.cacheTransferValueUSDL = BiMath_1.BiMath.Zero;
        this._view.selectedVSToTransfer = null;
    }
    tokenizeReset() {
        const ctrl = this._view.ctrls;
        ctrl.iTokenizeValueUSDL.value = '';
        ctrl.lTokenizeTxFee.text = "0";
        ctrl.lTokenizeTxLoan.text = "0";
        ctrl.lTokenizeTxMint.text = "0";
        ctrl.btnTokenizeSubmit.disable();
        ctrl.blockTokenizeOverview.hide();
        ctrl.blockDetokenizeOverview.show();
    }
    detokenizeReset() {
        const ctrl = this._view.ctrls;
        ctrl.iDetokenizeValueUSDL.value = '';
        ctrl.lDetokenizeTxBurn.text = "0";
        ctrl.lDetokenizeTxFee.text = "0";
        ctrl.lDetokenizeTxLoan.text = "0";
        ctrl.btnDetokenizeSubmit.disable();
        ctrl.blockDetokenizeOverview.hide();
        ctrl.blockTokenizeOverview.show();
    }
    claimReset() {
        const ctrl = this._view.ctrls;
        ctrl.lTxClaimValue.text = "0";
        ctrl.btnClaimSubmit.disable();
    }
    awaitInLockUIAsync(promise) {
        return __awaiter(this, void 0, void 0, function* () {
            this._view.disable();
            try {
                const result = yield promise;
                this._view.enable();
                return result;
            }
            catch (error) {
                this._view.enable();
                throw error;
            }
        });
    }
}
exports.LoanCalcViewController = LoanCalcViewController;
//# sourceMappingURL=LoanCalcViewController.js.map